import { Box, Flex, IconChevronRight, Modal } from '@phx/design-system';
import { useTranslation } from 'react-i18next';

import type { MedicationEquivalent } from '../../graphql/generated/graphql';
type DrugFamilyEquivalentsModalProps = {
    drugName: string;
    equivalents: MedicationEquivalent[];
    opened: boolean;
    handleClick: (id: string, name: string) => void;
    toggle: () => void;
};

export const DrugFamilyEquivalentsModal = ({
    drugName,
    equivalents,
    opened,
    handleClick,
    toggle,
}: DrugFamilyEquivalentsModalProps) => {
    const { t } = useTranslation();

    const modalTitle = `${drugName} ${t(equivalents[0].brandNameCode, {
        ns: 'code-locales/brand-name-code-mapping',
        count: 1,
    })}s`;

    return (
        <Modal opened={opened} onClose={toggle} title={modalTitle}>
            {equivalents.map((eq) => (
                <Flex
                    key={eq.id}
                    component="a"
                    onClick={() => handleClick(eq.id, eq.name)}
                    justify="space-between"
                    align="center"
                    style={{
                        cursor: 'pointer',
                        width: '100%',
                    }}
                >
                    <Box style={{ flex: 1 }}>{eq.name}</Box>

                    <Box style={{ alignSelf: 'start' }}>
                        <IconChevronRight />
                    </Box>
                </Flex>
            ))}
        </Modal>
    );
};
